import { createSlice } from '@reduxjs/toolkit';

import { Modal, Toast } from '@/types';

const name = 'ui';

type UiState = {
  modals: Modal[];
  toasts: Toast[];
  isSidebarOpen: boolean;
};

const initialState: UiState = {
  modals: [],
  toasts: [],
  isSidebarOpen: false,
};

export const uiSlice = createSlice({
  name,
  initialState,
  reducers: {
    setActiveModal: (state, { payload }: { payload: Modal }) => {
      state.modals = [payload, ...state.modals];
    },
    closeActiveModal: state => {
      if (state.modals.length === 0) return;

      state.modals = state.modals.slice(1);
    },
    addToast: (state, { payload }: { payload: Toast }) => {
      state.toasts = [payload, ...state.toasts];
    },
    removeToast: (state, { payload }: { payload: string }) => {
      state.toasts = state.toasts.filter(t => t.id !== payload);
    },
    toggleSidebarDrawer: state => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    closeSidebarDrawer: state => {
      state.isSidebarOpen = false;
    },
  },
});

export const uiActions = uiSlice.actions;
export const { reducer: uiReducer } = uiSlice;
export const UI_SLICE_KEY = name;
export const UI_SLICE_INITIAL_STATE = initialState;
